import { RouterProvider } from 'react-router-dom'
import { router } from '@/routes'
import { useTheme } from '@/hooks/useTheme'
import { Toaster } from '@/components/ui/use-toast'

function App() {
  // 初始化主题系统
  useTheme()

  return (
    <>
      {/* 路由 */}
      <RouterProvider router={router} />
      {/* Toast 通知容器 */}
      <Toaster />
    </>
  )
}

export default App
